/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/prefer-default-export */
import { AxiosResponse } from 'axios';
import { apinoticias } from './api';

export const getVideos = ({ page }: { page: number }): Promise<AxiosResponse> =>
  apinoticias.get(`/cms/videos/?page=${page}`);
